module.exports = __webpack_public_path__ + "01_long_brown.971acef2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/01_long_brown.png
// module id = fctm
// module chunks = 0